import { useEffect } from "react";

import { useT } from "@/shared/i18n/useT";

/** Name the browser tab after the page ("Projects · 404 OS"), so every page has its own title. */
export function useDocumentTitle(title: string | undefined) {
  const t = useT();
  const appName = t("app.name");

  useEffect(() => {
    document.title = title ? `${title} · ${appName}` : appName;
  }, [title, appName]);
}
